import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';
import { Globals } from '../_helpers';
import { AlertService, AuthenticationService } from '../_services';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
//import {DataTableModule} from "angular-6-datatable";

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./dashboard.component.css']
})


export class TransactionComponent implements OnInit {

  public alertOption: SweetAlertOptions = {};  
	@ViewChild('qpSelSwal') private qpSelSwal: SwalComponent;
	@ViewChild('createExamSwal') private createExamSwal: SwalComponent;
	@ViewChild('addinBatchSwal') private addinBatchSwal: SwalComponent;
  @ViewChild('msgSwal') private msgSwal: SwalComponent;	
  @ViewChild('closeBtn') closeBtn: ElementRef;
  reasonFormControl = new FormControl('', [
      Validators.required,
      Validators.minLength(4),
  ]);
  
  public data;
	title = 'Pareekshn';
	userinfo: any;
	studentid: number = 0;
	isErrorUsername: boolean;
	errorMsg: any;
	loading: boolean;
	isValid = true;
	pg: number = 0;
	usertoken: string;
	todayDate: Date = new Date();
	examicon: string;
	paymentlist = [];
	returnUrl: string;
	sectorid: number = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private globals: Globals,
    private spinner: NgxSpinnerService,
    private http: HttpClient
  ) { }

  ngOnInit() {

    //let auth_token = 'MTQ1YjE4ZDI2Mjc1MzQ4MGM2Njc5MTNlNDdmMWY2MGVfUGFyQDIzQE1F';
    this.userinfo = JSON.parse(localStorage.getItem('userinfo_ps')); //console.log(this.userinfo);
    this.studentid = this.userinfo['student_id'];
    this.usertoken = this.userinfo['usertoken'];
    var step = this.route.snapshot.paramMap.get("step");

    if(step == null || step == undefined)
    {
      this.returnUrl = '/sectors';
    }
    else{
      this.sectorid = parseInt(step);
    }   
    this.getTransactions();

/*    this.data = [{'name':'Anil', 'sdsadsa@gmail.com' :'ssd', 'age' :'34', 'city':'Noida, UP, India' },
   ];*/

  }

paymentArrLength;
payDate;
paystatus;
refundstatus;
refundButton:number = 0;
refund_amount:number = 0;
refund_reason: string = '';
refund_mode: string = '';
refunds;
getTransactions()
{ 
  this.loading = true;
  this.spinner.show();
    this.authenticationService.getTransactions(this.globals.root_url, this.studentid, this.usertoken)
      .pipe(first())
      .subscribe(
        data => {
          //console.log(data)
          if (data.code == 1000) {
            this.data = [];
            this.paymentlist = data.payments; 
            this.paymentArrLength = this.paymentlist.length; //console.log(this.paymentlist);
            for(var m =0; m < this.paymentArrLength; ++m)
            { 
              if(this.paymentlist[m].payment_date != null)
              {
                let ldt = this.paymentlist[m].payment_date; 
                let ldt_split = ldt.split("T");
                var d = new Date(ldt_split);
                this.payDate = this.formatDate(d); 
              }
              else{
                this.payDate = '';
              }

              switch(this.paymentlist[m].payment_status)
              {
                case -1: this.paystatus = 'Pending'; this.refundstatus = '';break;            
                case 0: this.paystatus = 'Failed'; this.refundstatus = '';break;            
                case 1: this.paystatus = 'Success';  
                  if(this.paymentlist[m].refund_allowed == 1 && this.paymentlist[m].exam_done == 0 && this.paymentlist[m].logged_in == 0 ) 
                  {
                    this.refundButton = 1;
                    this.refundstatus = 'Refund';
                  } else {
                    this.refundButton = 0;
                  }
                  break;            
                case 2: this.paystatus = 'Success'; this.refundButton = 2; this.refundstatus = 'Refund Requested';break;            
                case 3: this.paystatus = 'Success'; this.refundstatus = 'Refunded'; this.refundButton = 3; break;  
                default: this.paystatus = ''; break;                        
              }  
              if(this.paymentlist[m].refunds[0] != null)
              {
                this.refunds = this.paymentlist[m].refunds[0];
                this.refund_reason = this.refunds.refund_request_reason;   
                this.refund_amount = this.refunds.refund_amount;  
                if(this.refunds.refunds[0] != null) 
                {
                  this.refund_mode = this.refunds.refunds[0].refund_mode; //console.log(this.refund_mode);
                }               
              }
              else
              {
                if(this.refund_amount == 0)
                {
                  this.refund_amount = this.paymentlist[m].amount_paid;
                }
              }

              this.data.push({ exam_name: this.paymentlist[m].exam_name, payment_mode: this.paymentlist[m].payment_mode, payment_date: this.payDate, amount_paid: this.paymentlist[m].amount_paid, payment_status: this.paystatus, refundstatus: this.refundstatus, refundButton: this.refundButton, refund_reason: this.refund_reason, refund_amount:this.refund_amount, refund_mode:this.refund_mode, payment_id:this.paymentlist[m].id, order_id:this.paymentlist[m].order_id, exam_fee_id:this.paymentlist[m].id_exam_fee, exam_id:this.paymentlist[m].id_exam });         
            }            
            //console.log(this.data);
            this.loading = false;
            this.spinner.hide();
          }
          else if(data.code == 1001)
          {
            this.errorMsg = data.status;
            this.loading = false;
            this.spinner.hide();
          }
          else  if(data.code == 1002){
            this.loading = false;
            this.spinner.hide();
            this.router.navigateByUrl('/userlogin'); 
          }
          
        },
        error => {
          this.errorMsg = 'No Result Found !!';
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
 }
 goDashboard()
 {
  this.router.navigateByUrl('/dashboard'); 
 }  
 refundreq()
 {

 }
 reason: string = '';
 reasondetail: string = '';
 refundmode: string = '';
 refunddetail(reason,reasondetail,mode)
 {
   if(reason)
   {
    this.reasondetail = ''; 
    this.refundmode = ''; 
    this.reason = reason;      
   }  

   if(reasondetail) 
   {
     this.reasondetail = reasondetail; 
     this.refundmode = mode; 
     this.reason = '';
   }
 }
 refundAmt = 0;
 payid = 0;
 orderid = '';
 examfee_id = 0;
 examid = 0;
 refundRequest(refundAmt, payid, orderid, examfee_id, examid)
 {
   this.refundAmt = refundAmt;
   this.payid = payid;
   this.orderid = orderid;
   this.examfee_id = examfee_id;
   this.examid = examid;
 } 
 submitted: boolean = false;
 isErrorLogin: boolean = false;
 isSuccess: boolean = false;
 succMsg = '';
 keys : any;
 onSubmitRefReq()
 {
  this.submitted = true;
  /* stop here if form is invalid */
  if (this.reasonFormControl.value == '') {
      this.isErrorLogin = true;
      return false;
  }
  else {
    this.loading = true;
    this.spinner.show(); console.log(this.usertoken)
    this.authenticationService.refundRequestsubmit(this.globals.root_url, this.usertoken, this.studentid, this.reasonFormControl.value, this.refundAmt, this.payid, this.orderid, this.examfee_id, this.examid)
        .pipe(first())
        .subscribe(
            data => {
                if (data.code == 1000) {
                    this.isErrorLogin = false; 
                    this.isSuccess = true;   
                    this.loading = false;
                    this.spinner.hide();    
                    this.succMsg = "Refund request has been submitted. !!";                                           
                    let that = this;
                    that.keys = setInterval(() => {
                      if(that.isSuccess == true)
                      {
                        clearInterval( that.keys ); 
                        that.closeModal();  
                        this.router.navigateByUrl('/dashboard');                   
                      }
                    }, 2000); 
                }
                else {
                    this.isErrorLogin = true;
                    this.errorMsg = data.status;
                    this.loading = false;
                }
                this.spinner.hide();
            },
            error => {
                this.isErrorLogin = true;
                this.errorMsg = 'Something Went Wrong !!';
            }
        );
  }   
 }
  closeModal() {
    this.closeBtn.nativeElement.click();
  }    
  formatDate(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0'+minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return (date.getMonth()+1) + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
  }
}





